"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConnectionStatus = void 0;
var getConnectionStatus_1 = __importDefault(require("./getConnectionStatus"));
exports.getConnectionStatus = getConnectionStatus_1.default;
